import React, { useContext, useState, useEffect } from 'react';
import './App.css';
import Layer from './components/Layer';
import Preset from './components/Preset';
import Stage from './components/Stage';
import OpenPSD from './components/OpenPSD';
import TopMenu from './components/TopMenu';
import { SettingsBannerContext } from './contexts/SettingsBannerContext';
import { MasterBannerContext } from './contexts/MasterBannerContext';
import CryptoJS from 'crypto-js'; 
import { GetArrayTxtIndex } from './helpers/fileManager';
import Animation from './components/Animation';
import { CreateHash, getBannerSize } from './helpers/buildBanner'
import { getOriginalAsset, getAsset } from './helpers/assets';
import Video from './components/Video'
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { generateUUID } from './helpers/assets';
import { ConvertBanner } from './helpers/exportBanner';
import { base64ToBlob } from './helpers/exportBanner';
import { GetBannerSize } from './helpers/fileManager';

function App() {
  const { setReload, fullScreenRight, fullScreenLeft, masterMotion, setLoading, loading, layerActive, setLayerActive, setError, videoModal, selectBannerModal, setSelectBannerModal, listaBanners, setListaBanners } = useContext(SettingsBannerContext);
  const { master, setMaster, setUndo, ctrl, setCtrl, setAssets, assets} = useContext(MasterBannerContext);
  const [ checkMaster, setCheckMaster ] = useState(null);

  function PSDtoBanner() {
    var banner = window.psdTree;
    var listAssets = window.assets;

    banner.hash = CreateHash(banner);
    setTimeout(function(){
      setReload(true);
     }, 10);
    var masterCopy = JSON.parse(JSON.stringify(banner));
    const steps = banner.elements[banner.elements.length - 1].step;
    for (let t = 1; t <= steps; t++) {
      const elements = banner.elements.filter(el => el.step === t);
      for (var j = 0; j < elements.length; j++) {
        var animation = {};  
        animation.in = {animation: !elements[j].parent ? "Suave" : "Estatico", direction: "Left", duration: 1000, delay: !elements[j].parent ? 0.1 : 0};
        animation.out = {animation: "Fade", direction: "Left", duration: 1000, delay: j === 0 ? 5 : 0};

        for (var w = 0; w < banner.elements.length; w++) {
          if (banner.elements[w].id === elements[j].id) {
            masterCopy.elements[w].animation = animation;
            break;
          }
        }
      }
    }
    masterCopy.elements[0].animation.in.animation = "Estatico";
    masterCopy.elements[0].animation.in.delay = 0;
    setLayerActive([{element: masterCopy.elements[0], type: "in"}]);
    
    var copyListaBanners = {
      master: masterCopy,
      listaReplicas: [],
      active: masterCopy
    }
    
    masterCopy.html = ConvertBanner(masterCopy);
    masterCopy.size = parseInt(GetBannerSize(masterCopy.html));
    
    setAssets(listAssets);
    setListaBanners(copyListaBanners);
    setMaster(masterCopy);
  }

  function PsdUpdate() {    
    var b64Update = window.psdTreeUpdate;
    var masterCopy = JSON.parse(JSON.stringify(master));
    var changed = false;
    var listAssets = JSON.parse(JSON.stringify(assets));
    b64Update.forEach(element => {
      masterCopy.elements.forEach((elementBanner, index) => {
        if (element.id  === elementBanner.id) {
          changed = true;
          masterCopy.elements[index].properties.background = element.b64;
          masterCopy.elements[index].properties.originalBackground = element.b64;
          const indexAsset = listAssets.findIndex(a => a.uuid === elementBanner.properties.asset);
          if (indexAsset > -1) {
            listAssets[indexAsset].data = element.b64;
          }
          const blob = base64ToBlob(element.b64);
          const blobUrl = URL.createObjectURL(blob);
          masterCopy.elements[index].properties.blob = blobUrl;
          masterCopy.elements[index].properties.width = element.width;
          masterCopy.elements[index].properties.height = element.height;
          masterCopy.elements[index].properties.top = element.top;
          masterCopy.elements[index].properties.left = element.left;
        }
      });
    });
    if (changed) masterCopy.hash = CreateHash(masterCopy);
    console.log('listAssets')
    console.log(listAssets)
    setAssets(listAssets);
    setMaster(masterCopy);
    setReload(true);
  }
  
  async function LoadReanimateFile() {
    setLoading({show: true, progress: false})
    var decryptFile = window.reanimateFile;
    var bytes = CryptoJS.AES.decrypt(decryptFile, '%G@g$#@FDcxzHJd234@#%');    
    var file = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    var masterCopy = JSON.parse(GetArrayTxtIndex("<master>", "</master>", file)[0]);
    const replicasSaved = GetArrayTxtIndex("<replica>", "</replica>", file, false, false);
    let listAssets = GetArrayTxtIndex("<assets>", "</assets>", file, false, false);
    listAssets = listAssets && listAssets.length > 0 ? JSON.parse(listAssets[0]) : [];
    listAssets = !listAssets ? [] : listAssets;
    const old = listAssets.length === 0;
    if (!masterCopy.hash) {
      const hash = CreateHash(masterCopy);
      masterCopy.hash = hash;
    }
    
    for (var j = 0; j < masterCopy.elements.length; j++) {
      if (old) {          
        const uuid = generateUUID();
        listAssets.push({
          uuid: uuid,
          data: masterCopy.elements[j].properties.originalBackground
        });
        masterCopy.elements[j].properties.asset = uuid;
      }
      if (masterCopy.elements[j].properties.asset) {
        // masterCopy.elements[j].properties.background = await getAsset(listAssets, masterCopy.elements[j].properties.asset, masterCopy.optimize);
        masterCopy.elements[j].properties.background = '';
        masterCopy.elements[j].properties.originalBackground = getOriginalAsset(listAssets, masterCopy.elements[j].properties.asset);
        const blob = base64ToBlob(masterCopy.elements[j].properties.originalBackground);
        const blobUrl = URL.createObjectURL(blob);
        masterCopy.elements[j].properties.blob = blobUrl;
      }
    }

    // masterCopy.html = ConvertBanner(masterCopy);
    // masterCopy.size = parseInt(GetBannerSize(masterCopy.html));

    const listarReplicasSaved = [];
    for (var i = 0; i < replicasSaved.length; i++) {
      try {
      const repl = JSON.parse(replicasSaved[i]);
      for (var j = 0; j < repl.elements.length; j++) {
        if (repl.elements[j].properties.asset) {
          // repl.elements[j].properties.background = await getAsset(listAssets, repl.elements[j].properties.asset, repl.optimize);
          repl.elements[j].properties.background = '';
          repl.elements[j].properties.originalBackground = getOriginalAsset(listAssets, repl.elements[j].properties.asset);
          const blob = base64ToBlob(repl.elements[j].properties.originalBackground);
          const blobUrl = URL.createObjectURL(blob);
          repl.elements[j].properties.blob = blobUrl;
          repl.html = ConvertBanner(repl);
          // repl.size = parseInt(GetBannerSize(repl.html));
        }
      }
      listarReplicasSaved.push(repl);
    } catch {}   
    }
    var copyListaBanners = {
      master: masterCopy,
      listaReplicas: listarReplicasSaved
    }
    setListaBanners(copyListaBanners);
    
    if (listarReplicasSaved && listarReplicasSaved.length && listarReplicasSaved[0] !== null) {
      setSelectBannerModal(true);
      setLoading({show: false, progress: false});
    } else {
      copyListaBanners.active = masterCopy;
      setMaster(masterCopy);
      setLayerActive([{element: masterCopy.elements[0], type: "in"}]);
      setTimeout(function(){
        setReload(true);
      }, 10);
      updateBackgroundElements(masterCopy, listAssets);
    }
      console.log('3')
    console.log('listAssets')
    console.log(listAssets)
    setAssets(listAssets);
    setLoading({show: false, progress: false});

  }


  async function updateBackgroundElements(banner, assets) {
    for (let i = 0; i < banner.elements.length; i++) {
      if (banner.elements[i].properties.background === '') {
        banner.elements[i].properties.background = await getAsset(assets, banner.elements[i].properties.asset, banner.optimize);
      }
    }
    setMaster(banner);
  }


  function handleKeyDown(key) {
    if (key === "Control" || key === "Meta") setCtrl(true);
    else if (key === "z" && ctrl) setUndo(true);
  }

  function handleKeyUp(key) {
    if (key === "Control" || key === "Meta") setCtrl(false);
  }

  const [divWidth, setDivWidth] = useState('100%')

  useEffect(() => {
    function handleResize() {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1280 && windowWidth <= 1359) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidth('100%');
          } else if (fullScreenLeft) {
            setDivWidth('80%');
          } else if (fullScreenRight) {
            setDivWidth('78%');
          } else {
            setDivWidth('57.7%');
          }
        } else if (windowWidth >= 1360 && windowWidth <= 1439) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidth('100%');
          } else if (fullScreenLeft) {
            setDivWidth('80%');
          } else if (fullScreenRight) {
            setDivWidth('78.5%');
          } else {
            setDivWidth('58.7%');
          }
        } else if (windowWidth >= 1440 && windowWidth <= 1599) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidth('100%');
          } else if (fullScreenLeft) {
            setDivWidth('81.1%');
          } else if (fullScreenRight) {
            setDivWidth('79.7%');
          } else {
            setDivWidth('61%');
          }
        } else if (windowWidth >= 1600 && windowWidth <= 1799) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidth('100%');
          } else if (fullScreenLeft) {
            setDivWidth('84%');
          } else if (fullScreenRight) {
            setDivWidth('80.5%');
          } else {
            setDivWidth('62.5%');
          }
        } else if (windowWidth >= 1800) {
          if (fullScreenLeft && fullScreenRight) {
            setDivWidth('100%');
          } else if (fullScreenLeft) {
            setDivWidth('84%');
          } else if (fullScreenRight) {
            setDivWidth('83%');
          } else {
            setDivWidth('67%');
          }
        }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenLeft, fullScreenRight]);

  async function handleSetMaster() {
    var copyListaBanners = JSON.parse(JSON.stringify(listaBanners));
    copyListaBanners.active = checkMaster;
    setLayerActive([{element: checkMaster.elements[0], type: "in"}]);
    setTimeout(function(){
      setReload(true);
    }, 10);
    setListaBanners(copyListaBanners);
    setMaster(checkMaster);
    setSelectBannerModal(false);
    updateBackgroundElements(checkMaster, assets);
  }

  return (
    <div style={{width: '100vw', height: '100vh', overflow: 'hidden'}}>
      {
        selectBannerModal ?
        <div className='modal-select-banner'>
          <div className='modal-select-banner-box'>
            <span className='modal-select-title'>Escolha a replica para edição</span>
            <div style={{marginTop: '15px'}}>
              {
                listaBanners.master ?
                <div className='modal-select-banner-item'>
                  <Checkbox checked={checkMaster === listaBanners.master } onChange={() => setCheckMaster(listaBanners.master)}></Checkbox>
                  {listaBanners.master.width}x{listaBanners.master.height} (master)
                </div>
                : <></>
              }
            </div>
            {
              listaBanners.listaReplicas.map(item => (
                <div className='modal-select-banner-item'>
                  <Checkbox checked={checkMaster === item} onChange={() => setCheckMaster(item)}></Checkbox>
                  {item.width}x{item.height}
                </div>
              ))
            }
          <Button style={{marginTop: '15px'}} onClick={() => handleSetMaster()} disabled={!checkMaster} variant="outlined">Aplicar</Button>
          </div>
        </div>
        :
        <></>
      }
      <div style={{position: 'absolute', width: '100%', height: '100%', background: 'rgba(0, 0, 0,0.7)', 
        display: loading.show ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center', zIndex: '1000000000000000', flexDirection: 'column'}}>
        <div className="lds-facebook"><div></div><div></div><div></div></div>
        {
          loading.progress ?
          <div style={{position: 'relative', width: '300px', height: '30px', background: 'rgba(0, 0, 0,0.7)', borderRadius: '15px'}}>
            <span style={{ position: 'absolute', color: 'white', left: '137px',}}>{parseInt(loading.progress)}%</span>
            <div style={{transition: 'width 5s', width: loading.progress + "%", height: '30px', background: '#DC1A59',
            borderRadius: loading.progress < 95 ? '15px 0 0 15px'  : '15px'}}></div>
          </div>
          :
          <></>
        }
      </div>
      <TopMenu/>
      <button id='PSDtoBannerButton' style={{display: 'none'}} onClick={() => PSDtoBanner()}/>
      <button
        id='ErrorLoadFile'
        style={{display: 'none'}}
        onClick={
          () => setError(
            {
              lista: [],
              mensagem: document.getElementById("span-error-file").innerHTML,
              show: true
            }
          )
        }
      />
      <span id="span-error-file" style={{display: 'none'}}>Formato de arquivo inválido</span>
      <button id='PsdUpdate' style={{display: 'none'}} onClick={() => PsdUpdate()}/>
      <div id='load-reanimate-file' style={{display: 'block'}} onClick={async () => await LoadReanimateFile()}></div>
      {master == null ?
      <OpenPSD/> :
      <div tabIndex="0" onKeyUp={(e) => handleKeyUp(e.key)} onKeyDown={(e) => handleKeyDown(e.key)} style={{display: 'flex', width: '100%', height: 'calc(100% - 60px)'}}>
        { videoModal ? <Video/> : <></> }
        <Layer/>
        <div style={{width: divWidth, transition: 'width 500ms', backgroundColor: '#F7F7F7',  height: '100%', display: 'flex', flexDirection: 'column'}}>
          <Stage master={masterMotion}/>
          <Preset/>
        </div>
        <Animation layer={layerActive}/>
      </div>
      }
    </div>
  );
}

export default App;